module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/firenze.31346ec92c0d4debe9abb8b08839066c.jpg";